import { render, staticRenderFns } from "./Export2.vue?vue&type=template&id=6c729d7c&lang=pug"
import script from "./Export2.vue?vue&type=script&lang=js"
export * from "./Export2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c729d7c')) {
      api.createRecord('6c729d7c', component.options)
    } else {
      api.reload('6c729d7c', component.options)
    }
    module.hot.accept("./Export2.vue?vue&type=template&id=6c729d7c&lang=pug", function () {
      api.rerender('6c729d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/orders/default/manage/Export2.vue"
export default component.exports